<template>
    <loader
        v-show="commonStore.loader"
        name="dots"
        object="#E47431"
        size="5"
        speed="2"
        bg="#343a40"
        objectbg="#999793"
        opacity="20"
        :disableScrolling="false"
    />
    <header-box-6 v-if="enabledStore.portalTypeBooks !== null"
    :bookPortal="enabledStore.portalTypeBooks"/>
    <main>
        <router-view/>
    </main>
    <footer-box-4/>
    <modal-access
        v-if="!isAuth"
        title="For registered users only"
        text="Please log in to your account or sign up to continue."
    />
</template>

<script>
import { useAuthStore, useCommonStore, useEnabledStore } from "@/stores";
import { RouterView } from "vue-router";
import HeaderBox6 from "./components/layouts/header/HeaderBox6.vue";
import FooterBox4 from "./components/layouts/footer/FooterBox4.vue";
import ModalAccess from "@/components/modals/ModalAccess.vue";

export default {
    components: {
        RouterView,
        HeaderBox6,
        FooterBox4,
        ModalAccess
    },
    data() {
        return {
            commonStore: useCommonStore(),
            authStore: useAuthStore(),
            enabledStore: useEnabledStore(),
        };
    },
    methods: {
        checkPortalType() {
            this.enabledStore.checkPortalType();
        },
    },
    created() {
      this.checkPortalType();
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
        isPortalTypeBooks() {
        return this.enabledStore.isPortalTypeBooks;
      },
    },
};
</script>


